import { allValues, Rights } from '../rights';

export const FACILITY_MANAGEMENT_RIGHTS = Object.freeze([
  ...allValues(Rights.RESIDENTS),
  Rights.EMPLOYEES.READ.key,
  Rights.EMPLOYEES.WRITE.key,
  ...allValues(Rights.EMPLOYEES.GENERAL),
  ...allValues(Rights.EMPLOYEES.CONTRACT),
  ...allValues(Rights.EMPLOYEES.SYSTEM_ACCESS),
  ...allValues(Rights.EMPLOYEES.CHECKLIST),
  ...allValues(Rights.EMPLOYEES.FILES),
  ...allValues(Rights.BASE_DATA),
  ...allValues(Rights.CARE),
  ...allValues(Rights.ADMINISTRATION_AND_INVOICING),
  ...allValues(Rights.GENERAL),
  Rights.ROSTER.MANAGE.key,
  Rights.ROSTER.ADMINISTRATE.key,
  Rights.ROSTER.PRINT.key,
  Rights.ROSTER.ACCESS.READ.key,
  Rights.ROSTER.ACCESS.WRITE.key,
  Rights.ROSTER.WEEK_PLAN.key,
  ...allValues(Rights.LISTS),
  ...allValues(Rights.ROSTER.VACATION_SCHEDULE),
]);
